const state = {
    rawmaterials: [],
    rawmaterialsID: [],
    loading: false,
    documents: [],
    file: null,
    docLoader: false,
};

export default state;